var React = require('react');

function OvalOuter (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},[React.createElement("circle",{"id":"path-101","cx":"708","cy":"2566","r":"371","key":0}),React.createElement("mask",{"id":"mask-202","maskContentUnits":"userSpaceOnUse","maskUnits":"objectBoundingBox","x":"0","y":"0","width":"742","height":"742","fill":"white","key":1},React.createElement("use",{"xlinkHref":"#path-101"}))]),React.createElement("g",{"id":"Pages","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","opacity":"0.502234323","strokeDasharray":"20","key":1},React.createElement("g",{"id":"Desktop-HD","transform":"translate(-337.000000, -2195.000000)","stroke":"#979797","strokeWidth":"2"},React.createElement("use",{"id":"Oval-Copy","mask":"url(#mask-202)","xlinkHref":"#path-101"})))]);
}

OvalOuter.defaultProps = {"width":"742px","height":"742px","viewBox":"0 0 742 742","version":"1.1"};

module.exports = OvalOuter;

OvalOuter.default = OvalOuter;
